module.exports = __webpack_public_path__ + "static/media/sama talking.c3563cf2.gif";